module.exports = __webpack_public_path__ + "static/media/uxui.1525e634.svg";


//////////////////
// WEBPACK FOOTER
// ./client/src/assets/images/uxui.svg
// module id = 385
// module chunks = 0